module.exports = __webpack_public_path__ + "img/顾客贡献榜.86a2719e.svg";